import { useContext } from 'react';
import { ErrorContext } from '../../lib/ErrorContext';
import Questions, { isSchedulingAnswerValid } from '~/lib/Questions';

export function isValidEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export function getEmailError(address) {
    if (address.indexOf('@') > -1) {
        return 'Email address is invalid';
    } else {
        return 'Email address is invalid, must contain @';
    }
}

export default function useValidation(questions, answers, questionRefs) {
    const { errors, setErrors, setErrorsUpdatedAt } = useContext(ErrorContext);

    // Go through questions and do client side validation
    //  use ErrorContext and setErrors on anything that fails
    //  return false on failure
    function validate() {
        setErrors({});
        let isValidateSuccess = true;

        function addError(id, message) {
            setErrorsUpdatedAt(new Date());
            setErrors(old => ({
                ...old,
                [`answers.${id}`]: [message],
            }));

            isValidateSuccess = false;
        }

        if (!questions) {
            return true;
        }

        for (const question of questions) {
            let answer = answers[question.id] || '';

            if (
                question.type === 'scheduling' ||
                question.type === 'classscheduling'
            ) {
                answer = !isSchedulingAnswerValid(answer)
                    ? ''
                    : answer?.startTime || answer[0]?.startTime;
            }

            if (typeof Questions[question.type]?.getValidationError === 'function') {
                const questionRef = questionRefs?.current?.[question.id];
                const message = Questions[question.type]?.getValidationError(
                    answer,
                    questionRef?.current,
                    question,
                );
                if (message) {
                    addError(question.id, message);
                }
            }

            if (question.type === 'contactinfo') {
                for (const contact of answer || []) {
                    if (contact?.email && !isValidEmail(contact.email)) {
                        addError(question.id, getEmailError(contact.email));
                    }
                }

                if (!answer?.length || !answer[0]?.name || !answer[0]?.email) {
                    addError(question.id, 'Please enter contact information');
                }
            }

            if (question.type === 'clientaccount') {
                answer = answer?.isLoggedIn ? 'loggedin' : '';
            }

            // Scheduling is always required
            const isRequired =
                question.settings?.required ||
                Questions[question.type]?.alwaysRequired;
            if (isRequired && !answer?.toString()?.trim()) {
                addError(question.id, 'This is required');
            }
        }

        return isValidateSuccess;
    }

    return {
        validate,
    };
}
